import * as React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-scroll';
import { useStickyBox } from 'react-sticky-box';

import './styles.scss';

interface Props {
  navs: { to: string, offset: number, label: string }[]
}

const StickySidebar = ({ navs }: Props) => {
  const [verticleOffset, setVerticleOffset] = React.useState(204);
  const anotherRef = React.createRef<HTMLDivElement>();

  const stickyRef = useStickyBox({
    offsetTop: verticleOffset,
  });

  React.useEffect(() => {
    const gettingTop = setTimeout(() => {
      if (anotherRef && anotherRef.current) {
        setVerticleOffset(anotherRef.current.getBoundingClientRect().top);
      }
    }, 2000);
    return () => {
      clearTimeout(gettingTop);
    };
  }, []);

  return (
    <div
      className="vertical-nav-wrapper"
      ref={stickyRef}
    >
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          borderRadius: '6px',
          padding: '20px 30px',
          boxShadow: '0px 8px 60px #00000005',
        }}
        className="vertical-nav-container"
        component="nav"
        ref={anotherRef}
      >
        <ul>
          {navs.map((nav) => (
            <li key={nav.to}>
              <Link
                to={nav.to}
                activeClass="active"
                spy
                smooth
                duration={500}
                offset={nav.offset}
              >
                {nav.label}
              </Link>
            </li>
          ))}
        </ul>
      </Box>
    </div>
  );
};

export default StickySidebar;
